import React from "react";
import "./EndCourses.css";
import SingleEndCourse from "./SingleEndCourse";

function EndCourses() {
  return (
    <section className="endCourses">
      <SingleEndCourse />
      <SingleEndCourse />
    </section>
  );
}

export default EndCourses;
